import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UrlService } from '@core/services/url/url.service';
import { FileDownloadService } from '@core/services/download/file-download.service';
import { FileSignatureManagerService } from '@core/services/files/file-signature-manager.service';

import * as Objects from '@core/objects';

@Component({
    selector: 'core-files-list-download',
    templateUrl: './files-list-download.component.html',
    styleUrls: ['./files-list-download.component.scss']
})
export class FilesListDownloadComponent {

    @Input() files: any;

    @Output() onClick = new EventEmitter<any>();

    public selected:boolean;

    constructor(public urlService: UrlService, 
        private fileDownloadSrv: FileDownloadService,
        private signatureManager: FileSignatureManagerService) { }

    click(file: any, i) {
        this.onClick.emit(file);
        this.selected = i;
    }

    download(file: any) {
        // Cast file to AmsFile for signature validation if it has access property
        const amsFile = file as Objects.AmsFile;
        // Use new signed file download if file has signature (access property)
        if (file && amsFile.access) {
            // Check if signature is expired
            if (this.signatureManager.isSignatureExpired(amsFile)) {
                // Signature expired - fall back to legacy download
                window.location.href = this.urlService.build('/files/'+file.id);
            } else {
                // Signature is valid, download with secure URL
                this.fileDownloadSrv.downloadFile(amsFile);
            }
        } else {
            // Fall back to legacy download method for files without signature
            window.location.href = this.urlService.build('/files/'+file.id);
        }
    }

}
